import React from 'react';
import CrsDataImportForm from './CrsDataImportForm';
import CrsAbsenteeMergeImportForm from './CrsAbsenteeMergeImportForm';
import { ImportResult, ImportSourceId } from './types';

interface ImportsPanelProps {
  selectedSourceId: ImportSourceId;
  selectedFiles: File[];
  onSelectFiles: (files: File[]) => void;
  onImport: () => void;
  absenteeFile: File | null;
  propertyFile: File | null;
  onSelectAbsentee: (file: File | null) => void;
  onSelectProperty: (file: File | null) => void;
  onAbsenteeMergeImport: () => void;
  importResult: ImportResult | null;
  onCloseResult: () => void;
  error: string | null;
  globalLoading: boolean;
  loadingMessage: string;
}

const ImportsPanel: React.FC<ImportsPanelProps> = ({
  selectedSourceId,
  selectedFiles,
  onSelectFiles,
  onImport,
  absenteeFile,
  propertyFile,
  onSelectAbsentee,
  onSelectProperty,
  onAbsenteeMergeImport,
  importResult,
  onCloseResult,
  error,
  globalLoading,
  loadingMessage
}) => {
  if (selectedSourceId === 'crs-data') {
    return (
      <CrsDataImportForm
        selectedFiles={selectedFiles}
        onSelectFiles={onSelectFiles}
        onImport={onImport}
        importResult={importResult}
        onCloseResult={onCloseResult}
        error={error}
        globalLoading={globalLoading}
        loadingMessage={loadingMessage}
      />
    );
  }

  if (selectedSourceId === 'crs-data-absentee-merge') {
    return (
      <CrsAbsenteeMergeImportForm
        absenteeFile={absenteeFile}
        propertyFile={propertyFile}
        onSelectAbsentee={onSelectAbsentee}
        onSelectProperty={onSelectProperty}
        onImport={onAbsenteeMergeImport}
        importResult={importResult}
        onCloseResult={onCloseResult}
        error={error}
        globalLoading={globalLoading}
        loadingMessage={loadingMessage}
      />
    );
  }

  return (
    <div className="app-welcome-message">
      <h2>Import</h2>
      <p>Select an import source from the list.</p>
    </div>
  );
};

export default ImportsPanel;
